import { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { Menu, X } from 'lucide-react'
import { useT } from '../../lib/i18n'

export default function TopBar() {
  const t = useT()
  const [scrolled, setScrolled] = useState(false)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const navItems = [
    { to: '/tanlov-tartibi', label: t('nav.tartib') },
    { to: '/nizom', label: t('nav.nizom') },
    { to: '/murojaat', label: t('nav.murojaat') },
  ]

  return (
    <header
      className={`sticky top-0 z-40 transition-all duration-300 ${
        scrolled
          ? 'bg-[var(--color-indigo-900)]/85 backdrop-blur-md border-b border-white/[0.08]'
          : 'bg-transparent'
      }`}
    >
      <div className="container-x flex items-center justify-between h-20 md:h-24">
        {/* Left: 2 ministry logos (clickable → home) */}
        <Link to="/" className="flex items-center gap-5 md:gap-7 shrink-0" aria-label={t('nav.home')}>
          <img
            src="/logos/vazirlik.png"
            alt="Maktabgacha va maktab ta'limi vazirligi"
            className="h-9 md:h-12 w-auto select-none"
            draggable="false"
          />
          <img
            src="/logos/agentlik.png"
            alt="Ixtisoslashtirilgan ta'lim muassasalari agentligi"
            className="h-9 md:h-12 w-auto select-none"
            draggable="false"
          />
        </Link>

        {/* Right: nav + register CTA */}
        <nav className="hidden lg:flex items-center gap-9">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `text-[15px] font-medium transition-colors ${
                  isActive
                    ? 'text-white'
                    : 'text-white/85 hover:text-white'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/royxatdan-otish"
            className="ml-2 px-6 py-2.5 bg-white text-[var(--color-indigo-800)] font-semibold rounded-full text-[13px] tracking-[0.08em] hover:bg-white/90 transition-colors"
          >
            {t('nav.register')}
          </Link>
        </nav>

        <button
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden w-10 h-10 flex items-center justify-center text-white"
          aria-label={open ? 'Menyuni yopish' : 'Menyu'}
          aria-expanded={open}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile drawer */}
      <div
        className={`lg:hidden overflow-hidden transition-[max-height,opacity] duration-300 ease-out ${
          open ? 'max-h-[480px] opacity-100' : 'max-h-0 opacity-0'
        } bg-[var(--color-indigo-900)] border-t border-white/[0.08]`}
      >
        <div className="container-x py-6 flex flex-col gap-2">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `py-3 px-3 rounded-[var(--radius-sm)] font-medium transition-colors ${
                  isActive ? 'bg-white/[0.08] text-white' : 'text-[var(--color-ink-muted)]'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/royxatdan-otish"
            onClick={() => setOpen(false)}
            className="mt-3 py-3 px-3 bg-white text-[var(--color-indigo-800)] font-semibold rounded-full text-center tracking-wider"
          >
            {t('nav.register')}
          </Link>
        </div>
      </div>
    </header>
  )
}
